export enum ProfilingChartType {
  Live = "admin.chart_live",
  LastHour = "admin.chart_last_hour",
}
